// extracted by mini-css-extract-plugin
export default {"container":"kF-z","dimension":"lF-z","dimensionLabels":"mF-z"};